<template>
  <div>
    <graph
      :title="adminText('workflowsAll.visitors_by_traffic_sources_2b85840', 'Visitors by traffic sources')"
      :data-filter="true"
      :has-data="hasData"
      :initial-date-range-option="initialDateRangeOption"
      :initial-date-range="initialDateRange"
      :value="
        data.primaryTrafficSource != null
          ? adminText('workflowsAll.traffic_share', '{{percent}}% from {{location}}', { percent: Math.round(data.primaryTrafficSourcePercentage), location: data.primaryTrafficSource })
          : ''
      "
      @changeDateRange="changeDateRange($event)"
    >
      <bar-chart :data="workflowUi(data)" :options="workflowUi({ indexAxis: 'y', barThickness: 35 })" />
    </graph>
  </div>
</template>
å
<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { GET_EVENT_VISITORS_TRAFFIC_SOURCE_STATS } from '../../../graphql/purchase.graphql'

import BarChart from '../../shared/graphs/bar-chart.vue'
import Graph from '../../shared/graphs/graph.vue'
import moment from 'moment'
export default {
  mixins: [WorkflowDisplay],
  name: 'visitors-by-source-graph',
  components: {
    BarChart,
    Graph,
  },

  props: ['eventId', 'initialDateRangeOption', 'initialDateRange', 'eventTemplateId'],

  data() {
    return {
      data: { datasets: [{ data: [] }] },
      endDate: this.initialDateRange[1],
      startDate: this.initialDateRange[0],
    }
  },
  computed: {
    hasData() {
      return this.data.datasets[0].data.length > 0
    },
  },

  methods: {
    changeDateRange(dateRangeObject) {
      this.startDate = moment(dateRangeObject.dateRange[0]).format('YYYY-MM-DD')
      this.endDate = moment(dateRangeObject.dateRange[1]).format('YYYY-MM-DD')
      this.filterByDate()
    },
    async filterByDate() {
      await this.$apollo.queries.getEventVisitorTrafficSourceStats.refetch()
    },
  },
  apollo: {
    getEventVisitorTrafficSourceStats: {
      query: GET_EVENT_VISITORS_TRAFFIC_SOURCE_STATS,
      variables() {
        return {
          from: this.startDate,
          to: this.endDate,
          eventId: this.eventId,
          eventTemplateId: this.eventTemplateId,
        }
      },
      result({ loading, data }) {
        if (!loading) {
          const {
            getEventVisitorTrafficSourceStats: { sources, ...rest },
          } = data
          this.data = {
            ...rest,
            labels: sources.map(e => e.name),
            datasets: [{ data: sources.map(e => e.total) }],
          }
        }
      },
    },
  },
}
</script>

<style scoped></style>
